import React from 'react';
import BloodTypeTable from './table';

class BloodType extends React.Component {
	render() {
		return(
			<div>
				<BloodTypeTable/>
			</div>
		);
	} 
}

export default BloodType;